// Constants.
// -----------------------------------------------------------------------------
// Default values.
export const ICON_DEFAULT_SIZE = 'l';
export const ICON_DEFAULT_SPIN = false;
//# sourceMappingURL=Icon.constants.js.map